import { ScheduleDateType } from "@/components/scheduledDateDropdown/scheduledDateDropdown";
import { DateTime } from "luxon";
import { canScheduleOrder } from "./dateTimeUtils";
import { daysOfWeek } from "@/components/merchantFooter/merchantFooter";

export const getSchedulableDateOptions = (
  scheduleDateRange: number,
  businessHours: any,
  timezone: string,
  leadTime?: number
): ScheduleDateType[] => {
  const today = DateTime.now().setZone(timezone);

  const dateOptions: ScheduleDateType[] = [];
  for (let i = 0; i <= scheduleDateRange; i++) {
    const date = today.plus({ days: i });
    const dayName = daysOfWeek[date.weekday % 7];
    const formattedDate = date.toFormat("MMM d");

    if (businessHours[dayName]?.length > 0) {
      const nowInMerchantZone = DateTime.now().setZone(timezone);
      if (
        canScheduleOrder(
          businessHours[dayName],
          nowInMerchantZone,
          timezone,
          leadTime,
          i === 0
        )
      ) {
        if (i === 0) {
          dateOptions.push({
            displayValue: "Today",
            dateObject: date.toJSDate(),
          });
        } else if (i === 1) {
          dateOptions.push({
            displayValue: `Tomorrow (${formattedDate})`,
            dateObject: date.toJSDate(),
          });
        } else {
          dateOptions.push({
            displayValue: formattedDate,
            dateObject: date.toJSDate(),
          });
        }
      }
    }
  }

  return dateOptions;
};
